export default "__VITE_ASSET__6eef1c6c__"